import React, { ReactNode, useEffect, useState } from 'react'
import { createFastContext } from '@rst/libs-ts'

const { Provider, useCtx } = createFastContext({ disable: false })

const DisableInteraction = ({
	children,
}: {
	children: (props: { ref: (el: HTMLElement) => void }) => ReactNode
}) => {
	const [ref, setRef] = useState<HTMLElement | null>(null)

	useEffect(() => {
		if (!ref) return undefined

		const fn = (e: MouseEvent) => {
			e.stopPropagation()
		}

		ref.addEventListener('click', fn, { capture: true })
		return () => {
			ref.removeEventListener('click', fn, { capture: true })
		}
	}, [ref])

	return (
		<Provider value={{ disable: true }}>{children({ ref: setRef })}</Provider>
	)
}

const useInteractionDisabled = () => useCtx().disable

export { DisableInteraction, useInteractionDisabled }
